<section class="container-md">

  <div class="container" style="padding-right: 0px;padding-left: 0px;">
    <div class="card">
      <div class="card-header">
        <h4 class="mb-0"><strong>Configuracion Extracto Bancario</strong></h4>
      </div>
      <div class="card-body">
        <p class="card-text">Registro de configuración Extracto Bancario</p>
        <form [formGroup]="formularioParam" class="form-group" novalidate>
          <div class="row justify-content-md-center">
            <div class="col-md-6">
              <div class="row 6">
                <div class="col-4">
                  <label for="diasTolerancia"><strong>Dias de tolerancia</strong></label>
                </div>
                <div class="col-4">
                  <app-lfsa-input (input)="this.formularioParam.get('valorParametroNum')" [claseLabel]="'letrasDanger'"
                                  [control]="this.formularioParam.get('valorParametroNum')"
                                  [id]="'valorParametroNum'"
                                  [type]="'number'"
                                  formControlName="valorParametroNum">
                  </app-lfsa-input>
                </div>
                <div class="col-4">
                  <button class="btn btn-success" (click)="guardarDiasTolerancia()">
                    <i class="fa fa-save"></i>
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <br/>


  <app-lfsa-card *ngIf="pageVisualizer === PAGE_VISUALIZER.INICIO" [innTemplate]="enviarTemplate"
                 [titulo]="'Banco / Operacion Interna '" [efecto]="true" [colapseName]="'enviarTemplate'" [banderaColapse]='true'>
  </app-lfsa-card>
  <ng-template #enviarTemplate>
    <div class="d-flex flex-row-reverse">
      <!--<button (click)="exportAsExcel()" class="btn btn-success">Exportar</button>-->
      <button (click)="toggleVisualizacion()" class="btn btn-success  mr-2" type="button" style="text-align: right;">
        <svg class="bi bi-plus-square-fill" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z"></path>
        </svg>
        Crear Nuevo
      </button>
      <button (click)="exportAsExcel()"  class="btn btn-success  mr-2" type="button" style="text-align: right;"><svg class="bi bi-filetype-xls" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM6.472 15.29a1.176 1.176 0 0 1-.111-.449h.765a.578.578 0 0 0 .254.384c.07.049.154.087.25.114.095.028.202.041.319.041.164 0 .302-.023.413-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .085-.29.387.387 0 0 0-.153-.326c-.101-.08-.255-.144-.462-.193l-.619-.143a1.72 1.72 0 0 1-.539-.214 1.001 1.001 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.527-.422.225-.1.484-.149.777-.149.305 0 .564.05.78.152.216.102.383.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.625.625 0 0 0-.247-.181.923.923 0 0 0-.369-.068c-.217 0-.388.05-.513.152a.472.472 0 0 0-.184.384c0 .121.048.22.143.3a.97.97 0 0 0 .405.175l.62.143c.217.05.406.12.566.211a1 1 0 0 1 .375.358c.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Zm-2.945-3.358h-.893L1.81 13.37h-.036l-.832-1.438h-.93l1.227 1.983L0 15.931h.861l.853-1.415h.035l.85 1.415h.908L2.253 13.94l1.274-2.007Zm2.727 3.325H4.557v-3.325h-.79v4h2.487v-.675Z"></path>
      </svg>Descarga .XLS</button>
    </div>
    <ng-container *ngIf="(this.dataSource$| async) as response">
      <div class="col-md-12 ">
      <ag-grid-angular [frameworkComponents]="frameworkComponents "
                       style="width: 100%; height:500px;"
                       class="ag-theme-alpine"
                       [rowData]="response.respuesta"
                       [columnDefs]="columnsConfig"
                       [pagination]="true"
                       [suppressAutoSize]="true"
                       [alwaysShowHorizontalScroll]="true"
                       [paginationPageSize]="50"
                       (gridReady)="onGridReady($event)"
                       [scrollbarWidth] = "20"
                       [localeText]="l10nAgGrid">
      </ag-grid-angular>
      </div>
    </ng-container>
  </ng-template>



  <app-lfsa-card *ngIf="pageVisualizer === PAGE_VISUALIZER.AGREGAR" [innTemplate]="TemplareAdd"
                 [titulo]="'Agregar Configuracion'" [efecto]="true" [colapseName]="'TemplareAdd'" [banderaColapse]='true'>
  </app-lfsa-card>

  <ng-template #TemplareAdd>

      <form [formGroup]="formulario" class="form-group" novalidate>
        <div class="row 12">
        <div class="form-group col-md-4" formGroupName="idEmpresa" >
          <app-lfsa-combo-box (change)="setBanco()" [claseLabel]="'letrasDanger'"
                              [comboBox]="cmbEmpresa"
                              [control]="formulario.get('idEmpresa')"
                              [idOpcion]="'idEmpresa'"
                              [opcion]="'dscaEmpresa'"
                              [id]="'empresa'"
                              [label]="'Empresa'"
                              formControlName="idEmpresa">
          </app-lfsa-combo-box>
        </div>
        <div class="form-group col-md-4" >
          <app-lfsa-select-opt-isp  (update)="formulario.get('idBanco').setValue($event);setCuenta(); setCodOperacionSap()"
                              [claseLabel]="'letrasDanger'"
                              [comboBox]="cmbBancos"
                              [control]="formulario.get('idBanco')"
                              [idOpcion]="'idBanco'"
                              [opcion]="'descripcionBanco'"
                              [id]="'idBanco'"
                              [label]="'Id Banco'"
                              formControlName="idBanco">
          </app-lfsa-select-opt-isp>
        </div>
       <div class="form-group col-md-4">
          <app-lfsa-input (input)="this.formulario.get('idCuenta')" [claseLabel]="'letrasDanger'"
                          [control]="this.formulario.get('idCuenta')"
                          [id]="'idCuenta'"
                          [isReadOnly]="'true'"
                          [label]="'No. Cuenta*'"
                          [type]="'string'"
                          formControlName="idCuenta">
          </app-lfsa-input>
        </div>

        <div class="form-group col-md-4" formGroupName="idOpInternaSap">
          <app-lfsa-select-opt-isp  (update)="formulario.get('codOperacionSap').setValue($event);"
                             [claseLabel]="'letrasDanger'"
                              [comboBox]="cmbOperaciones"
                              [control]="this.formulario.get('codOperacionSap')"
                              [idOpcion]="'codigo'"
                              [opcion]="'descripcion'"
                              [id]="'id'"
                              [label]="'Operacion SAP'"
                              formControlName="id">
          </app-lfsa-select-opt-isp>
        </div>
          <div class="form-group col-md-4" >
            <app-lfsa-combo-box [claseLabel]="'letrasDanger'"
                                [comboBox]="cmbTipoMovimiento"
                                [control]="formulario.get('tipoMovimiento')"
                                [idOpcion]="'codigo'"
                                [opcion]="'descripcion'"
                                [id]="'tipoMovimiento'"
                                [label]="'Tipo Movimiento*'"
                                formControlName="tipoMovimiento">
            </app-lfsa-combo-box>
          </div>
        <div class="form-group col-md-4">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'"
                              [comboBox]="cmbSignos"
                              [control]="formulario.get('signo')"
                              [idOpcion]="'codigo'"
                              [opcion]="'descripcion'"
                              [id]="'signo'"
                              [label]="'Signo*'"
                              formControlName="signo">
          </app-lfsa-combo-box>
        </div>

        </div>
        <div class="row">
          <div class="col-md-6">
            <button (click)="EnviarGuardar()" class="subscribe btn btn-success btn-lg btn-block" type="button">Guardar</button>
          </div>
          <div class="col-md-6">
            <button (click)="Cancelar()" class="subscribe btn btn-danger btn-lg btn-block" type="button">Cancelar</button>
          </div>
        </div>
      </form>

  </ng-template>

</section>

